module.exports = __webpack_public_path__ + "static/img/profileimagepng.c2ff71a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profileimagepng.png
// module id = mVyP
// module chunks = 0